import { customFetch } from 'utils/http';
import { EmailNotFoundError, UnexpectedError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  eMail: string;
};

export const processForgotPasswordMailForm = async (params: Params) => {
  const { eMail } = params;

  const fetchURL = getM8AuthURL('processForgotPasswordMailForm');

  const body = new FormData();

  body.append('eMail', eMail);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 404) {
      throw new EmailNotFoundError();
    }

    if (response.status === 400) {
      throw new EmailNotFoundError();
    }

    throw new UnexpectedError();
  }
};
